import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  BulkCreateAssignmentsInput,
  MutationCreateBulkAssignmentResponse,
  BulkCreateAssignmentsInputVariables,
} from '../types';

const createBulkFlexibleComponentsAssignmentsMutation = gql`
  mutation CreateBulkFlexibleAssignments($input: BulkCreateAssignmentsInput!) {
    payrollBulkCreateAssignments(input: $input) {
      assignment_ids
      code
      success
      message
    }
  }
`;

export const createBulkFlexibleComponentsAssignments = (
  input: BulkCreateAssignmentsInputVariables,
) => {
  return graphQLApi<MutationCreateBulkAssignmentResponse, BulkCreateAssignmentsInput>({
    query: createBulkFlexibleComponentsAssignmentsMutation,
    queryVariables: { input },
  });
};
